import React, { useState, useEffect } from 'react';
import { 
  BarChart3, 
  Code,
  Zap,
  RefreshCw,
  Home
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useUsageData } from '../contexts/UsageDataContext';
import { formatCurrency, getUserUsageLogs } from '../api/usage';
import { FREE_REQUESTS_PER_MONTH } from '../config/constants';
import CodeExamplesContent from './CodeExamplesContent';
import PageHeader from './PageHeader';
import './OverviewPage.css';

interface OverviewPageProps {
  apiKeys: any[];
}

const OverviewPage: React.FC<OverviewPageProps> = ({ apiKeys }) => {
  const { user } = useAuth();
  const { usageData, currentMonthUsage, loading, refreshData } = useUsageData();

  const apiKey = apiKeys.length > 0 ? apiKeys[0].key_prefix : 'YOUR_API_KEY';

  return (
    <div className="overview-page">
      <PageHeader
        icon={Home}
        title="Overview"
        subtitle="Your API dashboard and quick start guide"
        actions={
          <button 
            onClick={() => refreshData()}
            disabled={loading}
            className="refresh-button"
          >
            <RefreshCw className={`refresh-icon ${loading ? 'spinning' : ''}`} size={16} />
            {loading ? 'Loading...' : 'Refresh'}
          </button>
        }
      />

      {/* Usage Stats Section */}
      <div className="usage-stats-section">        
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-content">
              <div className="stat-icon">
                <Zap className="icon" />
              </div>
              <div className="stat-info">
                <div className="stat-label">API Calls</div>
                <div className="stat-description">This month</div>
              </div>
              <div className="stat-value">
                {loading ? '...' : currentMonthUsage?.requests?.toLocaleString() || '0'}
              </div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-content">
              <div className="stat-icon">
                <BarChart3 className="icon" />
              </div>
              <div className="stat-info">
                <div className="stat-label">Total Cost</div>
                <div className="stat-description">This month</div>
              </div>
              <div className="stat-value">
                {loading ? '...' : formatCurrency(currentMonthUsage?.cost || 0)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Code Examples Section */}
      <div className="quick-start-section">
        <h2 className="section-title">Quick Start</h2>
        <CodeExamplesContent apiKey={apiKey} showDocumentation={false} />
      </div>
    </div>
  );
};

export default OverviewPage;